import { Injectable } from '@angular/core';
import { TranslationService } from '@schoolbelle/common/translation';
import { TimeLeftTranslationComponent } from './time-left-translation.component';

@Injectable({
  providedIn: 'root',
})
export class TimeLeftTranslationService {
  constructor(private translationService: TranslationService) {
    this.translationService.injectComponent(TimeLeftTranslationComponent);
  }
}
